import React from 'react';
import { Space, Typography } from 'antd';

interface Props {
  title: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  icon?: React.ReactNode;
  bodyStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

/**
 * 报告小模块标题：左侧蓝色竖线 + 加粗文本
 */
export const ReportSubTitle: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({ children, style }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
      <span style={{ width: 3, height: 14, background: '#1890ff', borderRadius: 2 }} />
      <Typography.Text strong>{children}</Typography.Text>
    </div>
  );
};

const ReportSection: React.FC<Props> = ({ title, extra, children, icon = '🔍', bodyStyle, style }) => {
  return (
    <div style={{ border: '1px solid #f0f0f0', borderRadius: 4, padding: 0, marginBottom: 24, ...style }}>
      <div
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#fafafa',
        }}
      >
        <Space>
          <Typography.Text strong>
            <span style={{ color: '#1890ff', marginRight: 8 }}>{icon}</span>
            {title}
          </Typography.Text>
        </Space>
        {extra ? <Space size="large" style={{ fontSize: 12, color: '#999' }}>{extra}</Space> : null}
      </div>
      <div style={{ padding: 16, ...bodyStyle }}>{children}</div>
    </div>
  );
};

export default ReportSection;
